export default class Tooltip {
  constructor(_canvas) {

   
  }

  /**
   * Create tooltip fo form measures
   */
  createTooltip(tooltipFormContent) {
    // Supprimer tous les anciens tooltips si existants
    this.removeTooltip();

    // Initialiser les tooltips pour chaque carte
    const cards = document.querySelectorAll(".cardProduct");

    

    cards.forEach((card) => {
        const openButton = card.querySelector(".openTooltip");
        if (!openButton) return; // Si pas de bouton dans cette carte, continuer
        
        openButton.addEventListener("click", (e) => {

            const subTypeInputHidden = openButton.dataset.subtype !== undefined ? `<input type="hidden" value="${openButton.dataset.subtype}" name="subType" >` : ``;

            const formContent = typeof tooltipFormContent === "object" && openButton.dataset.subtype !== undefined ? tooltipFormContent[openButton.dataset.subtype] : tooltipFormContent;

            // Supprimer toute div existante
            document.querySelector(".overlay-card")?.remove();            
        
            // Trouver la colonne parente de la carte
            const column = card.closest(".col-6");
            if (!column) {
                console.error("Impossible de trouver la colonne parente !");
                return;
            }
        
            // Vérifier si le parent existe avant de calculer l'index
            const parentRow = column.parentNode;
            const columnsInRow = Array.from(parentRow.children);
            const columnIndex = columnsInRow.indexOf(column);
        
            // Vérifier si la colonne cible est valide
            const siblingColumnOffset = columnIndex % 2 === 0 ? 1 : -1;
            const siblingColumnIndex = columnIndex + siblingColumnOffset;
        
            const validSibling = siblingColumnIndex >= 0 && siblingColumnIndex < columnsInRow.length;
            const targetCard = validSibling
                ? columnsInRow[siblingColumnIndex].querySelector(".cardProduct")
                : card;
        
            // Vérifier l'existence de targetCard avant de tenter d'accéder à getBoundingClientRect
            if (!targetCard) {
                console.error("La carte cible n'existe pas.");
                return;
            }
        
            const cardRect = card.getBoundingClientRect();
            const tooltipLeft = validSibling
                ? targetCard.getBoundingClientRect().left
                : cardRect.right + 10;
            const tooltipTop = validSibling
                ? targetCard.getBoundingClientRect().top
                : cardRect.top;
        
            // Créer une nouvelle div (overlay)
            const overlay = document.createElement("div");
            overlay.classList.add("overlay-card");
            overlay.classList.add("protected");
        
            // Appliquer les styles pour correspondre à la taille et à la position calculées
            overlay.style.position = "absolute";
            overlay.style.width = `${cardRect.width}px`;
            overlay.style.height = `${cardRect.height}px`;
            overlay.style.top = `${tooltipTop + window.scrollY}px`;
            overlay.style.left = `${tooltipLeft}px`;
            overlay.style.zIndex = "1000";
        
            // Ajouter un contenu ou un bouton de fermeture
            overlay.innerHTML = `
            <div class="p-3">
                <p class="m-0 barlow-bold" style="font-size:17px">Dimensions</p>
                <form class="mt-2 formMeasures">
                    ${formContent}
                    ${subTypeInputHidden}
                    <br>
                    <div class="text-center">
                        <button data-src="${e.target.dataset.src}" data-id="${e.target.dataset.id}" data-type="${e.target.dataset.type}" type="submit" class="btn iconAddProductTooltip submitFormMeasures">
                            <img src="./images/icons/icon_add_object_2.png" width="30"/>
                        </button>
                    </div>
                </form>
                <button class="btn p-1 buttonCloseTooltip" id="btn_close_tooltip"><img src="./images/icons/icon_close.png" width="20" /></button>
                <img id="icon_open_tooltip" src="./images/icons/icon_open_tooltip.png" width="30"/>
            </div>`;
        
            // Ajouter un événement pour fermer l'overlay
            overlay.querySelector(".buttonCloseTooltip").addEventListener("click", () => {
                overlay.remove();
            });
        
            // Ajouter l'overlay au document
            document.body.appendChild(overlay);
        
            // Ajuster l'icône d'ouverture du tooltip
            const iconTooltip = document.getElementById("icon_open_tooltip");
            if (validSibling && siblingColumnOffset === -1) {
                iconTooltip.style.right = "-30px";
                iconTooltip.style.transform = "rotate(180deg)";
            } else {
                iconTooltip.style.left = "-30px";
                iconTooltip.style.transform = "rotate(0deg)";
            }
        });
        
    });
}


  /**
   * Remove Tooltip
   */
  removeTooltip() {
    const tooltip = document.getElementsByClassName("overlay-card");
  
    if (tooltip.length > 0) {
      tooltip[0].remove();
    }
  }



}
